import type * as React from 'react';
import { del } from '@Domain/Api';
import beneficiaryContactDeleted, {
	type BeneficiaryContactDeletedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactDeleted';
import beneficiaryContactDeletionFailed, {
	type BeneficiaryContactDeletionFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactDeletionFailed';
import type DeleteBeneficiaryContact from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Commands/DeleteBeneficiaryContact';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = BeneficiaryContactDeletedAction | BeneficiaryContactDeletionFailedAction;

export default (command: DeleteBeneficiaryContact) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}/contacts/${command.contactId}`,
			);

			const action = beneficiaryContactDeleted({ contactId: command.contactId }, command.beneficiaryId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryContactDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
